import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/service/order-service';

@Component({
  selector: 'app-patient-detail',
  templateUrl: './patient-detail.component.html',
  styleUrls: ['./patient-detail.component.scss'],
  providers: [OrderService]
})
export class PatientDetailComponent implements OnInit {
  // @Input() isVisible: any;
  userId: any;
  users: any[];
  formAdd: FormGroup;
  pageSize: any;
  page: any;
  defaultPage: any;
  loading: boolean;
  groupResultValues = [];
  orderId: any;
  orderItem: any = {
    patient: {}
  };



  constructor(
    private orderService: OrderService,
    private router: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.router.params.subscribe(params => {
      this.orderId = params['id'];
      
    });
    this.getResultValue();
    this.getOrderDetail();
  }

  getOrderDetail() {
    this.orderService.getOrderById(this.orderId).subscribe(res => {
      if (res !== null) {
        this.orderItem = res;
        console.log(this.orderItem);
        
      }
    }, error => {
    });
  }

  getResultValue() {
    // console.log(this.orderItem);
    this.orderService.getOrderResultValues(this.orderId).subscribe(res => {
      if (res !== null) {
        console.log(res);
        const types = res.data.map(en => en.type.code);
        const distinctTypes = types.filter((n, i) => types.indexOf(n) === i);
        const ret = [];
        distinctTypes.forEach(specimenTypeCode => {
          console.log(specimenTypeCode, res.data);
          res.data.filter(en => en.type.code === specimenTypeCode).forEach(result => {
            let existsItem = ret.find(en => en.code === specimenTypeCode);
            if (!existsItem) {
              existsItem = {code: specimenTypeCode, name: result.type.name, items: []};
              ret.push(existsItem);
            }
            if (result) {
              result.value.machineName = result.machineName;
              existsItem.items.push(result.value);

            }
          });
        });
        this.groupResultValues = ret;
        console.log(this.groupResultValues);
      }
    }, error => {
    });
  }


  toTdCls(item: any) {
    if (item.resultType.unitType === 0){
      const val = +item.valueStr;
      if (val < item.resultType.normalMin || val > item.resultType.normalMax){
        return 'result-abnormal';
      }
      return 'result-normal';
    }
    else{
      return '';
    }
  }
}
